import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/globals.css';

// Base path from build-time config (set via VITE_BASE_PATH env var)
// React Router basename should not have trailing slash
declare const __BASE_PATH__: string;
let basePath = typeof __BASE_PATH__ !== 'undefined' ? __BASE_PATH__ : '/';
// Remove trailing slash for React Router (but keep '/' as is)
if (basePath !== '/' && basePath.endsWith('/')) {
  basePath = basePath.slice(0, -1);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={basePath}>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
